/**
 * Animate with IntersectionObserver
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 * Note: IntersectionObserver does not work in IE11, do not polyfill.
 * It is not crucial for IE11 to get these animations
 *
 * How it works:
 * Look through for elements with a class of `is-unanimated`
 * and change to `is-animated`.
 *
 * use CSS to fire the animations like so
 * ```
 * .is-animated > * {
 *   opacity: 1;
 *   transform: none;
 *   transition-property: opacity, transform;
 *   transition-timing-function: ease-in-out;
 *   transition-duration: 250ms;
 * }
 *
 * [data-html-class="js"] .is-unanimated > * {
 *   opacity: 0;
 *   transform: translateY(30px);
 * }
 * ```
 */

const animate = () => {
  const classes = {
    preAnimation: "is-unanimated",
    postAnimation: "is-animated",
  }
  const animatedElements = document.querySelectorAll(`.${classes.preAnimation}`)

  const IOCallback = (entries, observer) => {
    entries.forEach((entry) => {
      const intersectionRatio = entry.target.getAttribute(
        "data-animate-intersection-ratio"
      )

      if (intersectionRatio) {
        if (entry.intersectionRatio > intersectionRatio) {
          triggerAnimation(entry, observer)
        }
      } else if (entry.isIntersecting) {
        triggerAnimation(entry, observer)
      }
    })
  }

  const triggerAnimation = (entry, observer) => {
    entry.target.classList.replace(classes.preAnimation, classes.postAnimation)
    observer.unobserve(entry.target)
  }

  if ("IntersectionObserver" in window) {
    const options = {
      threshold: [0.25, 0.5, 0.75],
    }

    const windowWidth = window.innerWidth

    if (windowWidth < 960) {
      options.threshold = [0.2, 0.4, 0.5, 0.6, 0.8, 1]
    }
    const observer = new IntersectionObserver(IOCallback, options)

    animatedElements.forEach((animatedElement) => {
      observer.observe(animatedElement)
    })
  } else {
    // If we don't have IntersectionObserver then remove the classes
    // otherwise everything will be opacity: 0;
    for (var i = 0; i < animatedElements.length; i++) {
      animatedElements[i].classList.remove(classes.preAnimation)
      animatedElements[i].classList.add(classes.postAnimation)
    }
  }
}

export default animate
